module.exports = __webpack_public_path__ + "img/forms.d3ddc191.svg";